import { ClientTicketStatus } from '@bustickus/models-client';

function getTicketStatusText(status: ClientTicketStatus): string {
  if (status === 'active') {
    return 'Билет оплачен';
  }

  if (status === 'archive') {
    return 'Билет в архиве';
  }

  if (status === 'refund') {
    return 'Билет аннулирован';
  }

  if (status === 'payment_waiting') {
    return 'Ожидает оплату...';
  }

  if (status === 'canceled') {
    return 'Оплата отменена';
  }

  return status;
}

export default getTicketStatusText;
